import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { LeaveService } from 'app/modules/leave/services/leave.service';

interface DeleteMotivoDialogData {
    leaveId: number;
}

@Component({
    selector: 'app-delete-motivo-dialog',
    templateUrl: './delete-motivo-dialog.component.html',
    styleUrls: ['./delete-motivo-dialog.component.scss'],
    standalone: false
})
export class DeleteMotivoDialogComponent implements OnInit {

    public form: UntypedFormGroup;

    constructor(
        private dialogRef: MatDialogRef<DeleteMotivoDialogComponent>,
        private leaveService: LeaveService,
        private sharedService: SharedService,
        private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) private data: DeleteMotivoDialogData,
    ) { }

    ngOnInit(): void {

        // init form
        this.form = this.fb.group({
            "motivo": ["", Validators.required]
        });

    }


    // handle eliminar button click
    public OnEliminarButtonClick() {

        // validate form
        this.form.markAllAsTouched();
        if (!this.form.valid)
            return;

        // delete leave
        this.DeleteLeave(this.data.leaveId, this.form.get("motivo").value);

    }


    // delete leave
    private DeleteLeave(leaveId: number, motivo: string) {
        this.leaveService
            .DeleteLeave(leaveId, motivo)
            .subscribe(res => {

                if (res.code === 0) {

                    // reload leaves list
                    const emplooyeeId = localStorage.getItem('EmplooyeeID');
                    this.leaveService.PublishLeaves(Number(emplooyeeId));

                    // show message and close dialog
                    this.sharedService.ShowSnackBar("La baja fue eliminada exitosamente. ");
                    this.dialogRef.close();

                } else {
                    this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                    console.error("Server error: " + res.message);
                }

            }, err => {
                this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                console.error(err);
            });
    }

    // close dialog
    public Close() {
        this.dialogRef.close();
    }

}
